import { axiosGet } from '@/api/AxiosApi';
import { sendRequest, EndpointPayload } from '@/api/AxiosRequest';

const BALANCE_API_URL = process.env.REACT_APP_BALANCE_API_URL;

// 리워드 기간 목록 조회
export const readRewardPeriods = async (poolId: string) => {
  const payload: EndpointPayload = {
    path: `/assetfi/staking/rewards/periods?poolId=${poolId}`,
    apiUrl: BALANCE_API_URL,
  };

  return await sendRequest(payload, 'readRewardPeriods', axiosGet);
};

// 리워드 기간별 지급 상세 조회
export const readRewardPositions = async (rewardPeriodId: string) => {
  const payload: EndpointPayload = {
    path: `/assetfi/staking/rewards/positions?rewardPeriodId=${rewardPeriodId}`,
    apiUrl: BALANCE_API_URL,
  };

  return await sendRequest(payload, 'readRewardPositions', axiosGet);
};
